import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { SortDirection } from 'const';
import MainFont from 'ui/typography/mainFont';

import { DownArrow, HeaderTitle, StatusHeader } from './style';

export const Header = ({
  headerColumns,
  columnWidths,
  onSort,
  sortingInfo
}) => {
  const { t } = useTranslation();

  const handleClick = (e, i) => {
    e.stopPropagation();
    onSort(i.accessor);
  };
  return (
    <StatusHeader columns={headerColumns?.length} columnWidths={columnWidths}>
      {headerColumns?.map((item, index) => (
        <HeaderTitle
          key={index}
          colIndex={index}
          columnSpan={item.columnSpan}
          position={item.position}
          marginRight={item.marginRight}
          sortable={item.sortable}
          onClick={e => (item.sortable ? handleClick(e, item) : null)}
        >
          {item.headerType === 'text' && (
            <MainFont type="tableHeader">{t(item.accessor)}</MainFont>
          )}
          {item.sortable && (
            <DownArrow
              upsideDown={
                sortingInfo.sortingOn === item.accessor &&
                sortingInfo.sortingDirection === SortDirection.DESC
              }
            />
          )}
        </HeaderTitle>
      ))}
    </StatusHeader>
  );
};

Header.defaultProps = {
  sortingInfo: {
    sortingOn: '',
    sortingDirection: SortDirection.ASC
  }
};

Header.propTypes = {
  headerColumns: PropTypes.array,
  columnWidths: PropTypes.string,
  onSort: PropTypes.func,
  sortingInfo: PropTypes.object
};
